console.log("Hello, it's me, Chungus, I'm watching you");

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
var csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

/** Laravel Echo **/
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: true
});

/** Vue.js **/
import { createApp } from 'vue/dist/vue.esm-bundler';

const app = createApp({});

import HeroBanner from './components/HeroBanner/HeroBanner';
app.component('hero-banner', HeroBanner);

import EditHeroBanner from './components/HeroBanner/EditHeroBanner';
app.component('edit-hero-banner', EditHeroBanner);

import HeroBannerStatus from './components/HeroBanner/HeroBannerStatus';
app.component('hero-banner-status', HeroBannerStatus);

import HeroTypeSelect from './components/HeroBanner/HeroTypeSelect';
app.component('hero-type-select', HeroTypeSelect);

import LatestContent from './components/Posts/LatestContent';
app.component('latest-content', LatestContent);

import ContentBlock from './components/Posts/ContentBlock';
app.component('content-block', ContentBlock);

import ManagePostsTable from './components/Posts/ManagePostsTable';
app.component('manage-posts-table', ManagePostsTable);

import EventBlock from './components/Events/EventBlock';
app.component('event-block', EventBlock);

import EventRegistration from './components/Events/EventRegistration';
app.component('event-registration', EventRegistration);

import ManageEventsTable from './components/Events/ManageEventsTable';
app.component('manage-events-table', ManageEventsTable);

import ShippingInstructions from './components/Cart/ShippingInstructions';
app.component('shipping-instructions', ShippingInstructions);

import CartItems from './components/Cart/CartItems';
app.component('cart-items', CartItems);

import ManageItemsTable from './components/Items/ManageItemsTable';
app.component('manage-items-table', ManageItemsTable);

import ItemGallery from './components/Items/ItemGallery';
app.component('item-gallery', ItemGallery);

import ItemImages from './components/Items/ItemImages';
app.component('item-images', ItemImages);

import ItemOptions from './components/Items/ItemOptions';
app.component('item-options', ItemOptions);

import AddItemToCart from './components/Items/AddItemToCart';
app.component('add-item-to-cart', AddItemToCart);

import OrdersTable from './components/Orders/OrdersTable';
app.component('orders-table', OrdersTable);

app.mount('#app');


/** CKEditor **/
if ( document.querySelector('#editor') !== null ) {

  const CK = await import('./ckeditor');

  CK.Editor.create( document.querySelector('#editor'), {

    mediaEmbed: {
      previewsInData: true
    },

    ckfinder: {
      uploadUrl: 'ckeditor/upload?_token=' + csrf_token
    },

    removePlugins: ['Title', 'Markdown'],

    alignment: {
      options: [ 'left', 'right', 'center', 'justify' ]
    }

  });
}

/** Toast **/
import { Eggy } from '@s-r0/eggy-js';
window.Toast = function ( message ) {
  Eggy({ title: 'Success', message: message, type: 'success', position: 'top-left' });
}

window.ErrorToast = function ( message ) {
  Eggy({ title: 'Failure', message: message, type: 'error', position: 'top-left' });
}

// Navigation Component
var MenuOpen = false;
var UserProfile = document.getElementById("user-profile");
if ( UserProfile !== null ) {
  UserProfile.addEventListener("click", ToggleUserProfile);
  var UserActions = document.getElementById("user-actions");
}

function ToggleUserProfile() {
  MenuOpen = !MenuOpen;
  if ( MenuOpen ) UserActions.style.display = "block";
  else UserActions.style.display = "none";
}

const openMobileNavButton = document.getElementById("open-mobile-nav");
const closeMobileNavButton = document.getElementById("close-mobile-nav");
const MobileNav = document.getElementById("mobile-nav-container");

if ( openMobileNavButton != null ) {
  openMobileNavButton.addEventListener("click", ToggleMobileNav);
  closeMobileNavButton.addEventListener("click", ToggleMobileNav);
}

var mobileNavOpen = false;
function ToggleMobileNav () {
  mobileNavOpen = !mobileNavOpen;
  if ( mobileNavOpen ) MobileNav.style.display = "block";
  else MobileNav.style.display = "none";
}



window.TogglePostType = ( type ) => {
  document.getElementById("post-content").style.display = "block";
  document.getElementById("post-audio-file").style.display = type == "podcast" ? "block" : "none";
}

document.getElementsByName("type").forEach((element) => {
  if ( element.checked ) TogglePostType(element.value)
});


// Achievement unlocks an item
const unlockItemCheck = document.getElementById("unlock_item");

if ( unlockItemCheck != null ) {
  unlockItemCheck.addEventListener("click", ToggleAchievementItem)
}

var itemSelectOpen = false;
const ItemContainer = document.getElementById("item-container");
function ToggleAchievementItem () {
  itemSelectOpen = !itemSelectOpen;
  if ( itemSelectOpen ) ItemContainer.style.display = "block";
  else ItemContainer.style.display = "none";
}


// Give achievement to user
/*$('.grant-achievement-button').on('click', function(){
  axios.post('/admin/user/grant_achievement', {
    id: $(this).data('id'),
    achievement_id: $(this).parent().find('.achievement-select').val()
  })
  .then(function (response) {
      console.log(response);
  });
});

// Give role to user
$('.grant-role-button').on('click', function(){
  axios.post('/admin/user/grant', {
    id: $(this).data('id'),
    role_id: $(this).parent().find('.role-select').val()
  })
  .then(function (response) {
      console.log(response);
  });
});*/
